import * as Yup from 'yup';

export const getRegisterSchema = (t) => {
    return Yup.object().shape({
            name: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            last_name: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            email: Yup.string()
                .email(t('RegisterForm.email.invalid'))
                .required(t('FormCommon.required')),
            password: Yup.string().required(t('FormCommon.required')),
            re_password: Yup.string()
                .required(t('FormCommon.required'))
                .oneOf(
                    [Yup.ref("password"), null],
                    t('RegisterForm.rePassword.invalid')
                ),
            company_name: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            company_address: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            postcode_location: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            customer_number: Yup.string()
                .min(1, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            phone: Yup.string()
                .min(1, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
        });
}


export const getEditUserSchema = (t) => {
    return Yup.object().shape({
            name: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            last_name: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            email: Yup.string()
                .email(t('RegisterForm.email.invalid'))
                .required(t('FormCommon.required')),
            re_password: Yup.string()
                .oneOf(
                    [Yup.ref("password"), null],
                    t('RegisterForm.rePassword.invalid')
                ),
            company_name: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            company_address: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            postcode_location: Yup.string()
                .min(2, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            customer_number: Yup.string()
                .min(1, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
            phone: Yup.string()
                .min(1, t('FormCommon.tooShort'))
                .max(50, t('FormCommon.tooLong'))
                .required(t('FormCommon.required')),
        });
}